import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";

// Action Types
export const SET_NOTIFICATION_SETTINGS = "SET_NOTIFICATION_SETTINGS";
export const SAVE_SETTINGS_ERROR = "SAVE_NOTIFICATION_SETTINGS_ERROR";

// Thunk Action Creator
export const saveNotificationSettings = createAsyncThunk(
    "api/Notification/saveNotificationSettings",
    async (json, { dispatch }) => {

        try {
            const response = await axios.put(
                `${import.meta.env.VITE_PUBLIC_DOMAIN}Notification/saveNotificationSettings`,
                {
                    type: json.type,
                    active: json.active,
                    params: json.params
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            if (response.status == 200) {
                if (response.data === '') {
                    throw new Error("The last task has not been saved. Logging the user out");
                } else {
                    dispatch({
                        type: SET_NOTIFICATION_SETTINGS,
                        payload: response.data,
                    });
                }
            } else {
                throw new Error("Error saving notification settings");
            }

            

        }
        catch (error) {
            dispatch({ type: SAVE_SETTINGS_ERROR, payload: error });
        }
    }
);